module.exports = __webpack_public_path__ + "img/ppt.19294f41.png";